import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { usePreviousRouteStore } from '@pflegia/ui/stores/previous-route.store';

export const useRouteTracking = () => {
  const router = useRouter();
  const addToHistory = usePreviousRouteStore(state => state.addToHistory);

  useEffect(() => {
    if (router.isReady) {
      addToHistory(router.asPath);
    }
  }, [router.asPath, router.isReady, addToHistory]);
};
